<template>
    <div>    
        <div v-if="loading">
            <h5>Loading Notifications.. Please wait..</h5>
        </div>
        <div v-else>
            <template v-if="results.length == 0">
                <h6 class="text-center">No Notifications</h6>
            </template>
            <template v-else>
                <h6 class="p-2 pb-3 text-center">Notifications</h6>
                <vx-card>
                    <div slot="no-body">
                        <vs-list slot="no-body">
                            <template v-for="(item, index) in results">
                                <a href="#" @click.prevent="open_notification(item)" :key="index">
                                    <vs-list-item :style="[item.read ? {'background': 'white'} : {'background': '#F1F1F1'}]" :title="get_message(item)" class="text-black" :subtitle="get_subtitle(item)"></vs-list-item>
                                </a>
                                <template v-if="!(index+1 == results.length)">
                                    <vs-divider :key="index"/>
                                </template>
                            </template>
                        </vs-list>
                    </div>
                </vx-card>
                <div class="mt-base" style="display: flex; align-items: center; justify-content: center;">
                    <template v-if="mode == 'dropdown'">
                        <router-link :to="{name: 'notifications'}">
                            <vs-button color="primary" type="filled" size="small" class="text-center">Show All</vs-button>
                        </router-link>
                    </template>
                    <template v-else>
                        <vs-button color="primary" type="filled" size="small" class="text-center"  @click="load_more" v-if="next_url">Load More</vs-button>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { Request } from '../../utils/requests';
import moment from 'moment';

export default {
    props: {
        mode: {
            required: false,
            type:  String,
            default: 'page', // page or dropdown
        }
    },
    data() {
        return {
            results: [],
            api_errors: {},

            loading: false,
            total_results: null,
            next_url: null,

            notification_type: {
                ISSUE:           'i',
                DPR:             'd',
                STOCK:           's'  ,
                ASSET:           'a',
                SAFETY_PROGRAM:  'p',
                ACCOUNT:         'c',
                INTERNAL:        'r',
                SECURITY:        'y'
            },

            action_type: {
                CREATE: 'c',
                UPDATE: 'u',
                APPROVE: 'a',
                REJECT: 'r',
                SUBMIT_RESOLUTION: 's',
                VERIFY_APPROVE: 'va',
                VERIFY_REJECT: 'vr',
                CHANGE_ASSIGNEE: 'ca'
            },

            sub_type: {
                APPROVAL: 'a',
                RESOLUTION: 'r'
            },

            dpr_sub_type: {
                DPR_MONTHLY : 'm',
                DPR_DAILY   : 'd',
                DPR_ENTRY   : 'e'
            },

            issue_type: {
                highway: 'Corrective Maintenance',
                occupational: 'Occupational',
                hazard: 'Hazard',
                road_user_accident: 'Road User Accident',
                enroachment_row: 'Enroachment Row',
                vehicle_breakdown: 'Vehicle Breakdown',
                unauthorised_parking: 'Unauthorised Parking',
                traffic_violation: 'Traffic Violation',
                dead_animal_debris_removal: 'Dead Animal DebrisRemoval',
                material_damage: 'Material Damage',
                unauthorised_access: 'Unauthorised Access',
                unauthorised_media_cut: 'Unauthorised MediaCut',
                other: 'Other',
                routine_maintenance: 'Routine Maintenance',
                major_maintenance: 'Major Maintenance',
                electrical_maintenance: 'Electrical Maintenance',
            },

            mm_dpr_type: {
                mm_bituminous_concrete_overlay: 'Bituminous Concrete Overlay',
                mm_dense_bituminous_concrete_overlay: 'Dense Bituminous Concrete Overlay',
                mm_milling: 'Milling',
                mm_thermoplastic_road_marking: 'Thermoplastic Road Marking',
                mm_shoulder_raising: 'Shoulder Raising',
                mm_road_sruds_fixing: 'RoadSruds Fixing',
                mm_kerb_topping: 'Kerb Topping',
                mm_kerb_painting: 'Kerb Painting/Crash Barrier',
                mm_microsurfacing: 'Micro Surfacing',
                mm_tack_coat: 'Tack Coat',
            },

            month_value: {
                1: "Jan",
                2: "Feb",
                3: "Mar",
                4: "Apr",
                5: "May",
                6: "Jun",
                7: "Jul",
                8: "Aug",
                9: "Sep",
                10: "Oct",
                11: "Nov",
                12: "Dec",
            },

        }
    },
    mounted() {
        this.load_data()
    },
    methods: {
        load_data() {

            this.loading = true;
            let url = this.$store.state.apiendpoints.notifications

            Request(this, 'GET', url, {}).then(
                (res) => {
                    this.results = res.results
                    this.total_results = res.count
                    this.next_url = res.next;
                    this.loading = false;
                }, 
                (err) => {
                    this.loading = false;
                    this.$vs.notify({
                        time: 2500,
                        title: 'Error',
                        text: "Error while loading notification",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        load_more() {

            let url = this.next_url

            if (url) {
                this.$vs.loading();

                Request(this, 'GET', url, {}).then(
                    (res) => {
                        this.results = this.results.concat(res.results)
                        this.next_url = res.next;
                        this.$vs.loading.close();
                    },
                    (err) => {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                )
            }
        },
        open_notification(item) {

            if (item.read) {
                this.$router.push(this.get_router_link(item))

            } else {
                let url = this.$store.state.apiendpoints.notification + item.id + '/'
                let payload = {
                    read: true
                }

                Request(this, 'PATCH', url, null, payload).then(
                    (res) => {
                        this.$store.dispatch('organisation/updateUnreadNotification')
                        this.$router.push(this.get_router_link(item))
                    },
                    (err) => {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                )
            }


        },
        get_router_link(item) {

            if (item.notification_type == this.notification_type.ISSUE) {
                return this.get_issue_router_link(item)

            } else if (item.notification_type == this.notification_type.SAFETY_PROGRAM) {
                return this.get_safety_program_router_link(item)

            } else if (item.notification_type == this.notification_type.DPR && item.params.sub_type == this.dpr_sub_type.DPR_MONTHLY ) {
                return this.get_rm_dpr_monthly_router_link(item)

            } else if (item.notification_type == this.notification_type.DPR && item.params.sub_type == this.dpr_sub_type.DPR_ENTRY ) {
                return this.get_mm_dpr_entry_router_link(item)

            } else if (item.notification_type == this.notification_type.DPR && item.params.sub_type == this.dpr_sub_type.DPR_DAILY ) {
                return this.get_rm_dpr_daily_router_link(item)
            }

        },
        get_issue_router_link(item) {
            let issue_type  = item.module
            let issue_id = item.related_id
            let action_type = item.action_type

            if (action_type == this.action_type.CREATE) {
                return {name: 'issues-view', params: {issue_type: issue_type, issue_id: issue_id}}

            } else if(action_type == this.action_type.REJECT && item.params.sub_type==this.sub_type.APPROVAL) {
                return {name: 'issues-edit', params: {issue_type: issue_type, issue_id: issue_id}}

            } else if(action_type == this.action_type.UPDATE && item.params.sub_type==this.sub_type.APPROVAL) {
                return {name: 'issues-view', params: {issue_type: issue_type, issue_id: issue_id}}

            } else if(action_type == this.action_type.APPROVE && item.params.sub_type==this.sub_type.APPROVAL) {
                return {name: 'issues-resolution', params: {issue_type: issue_type, issue_id: issue_id}}

            } else if(action_type == this.action_type.SUBMIT_RESOLUTION && item.params.sub_type==this.sub_type.RESOLUTION) {
                return {name: 'issues-resolution', params: {issue_type: issue_type, issue_id: issue_id}}

            } else if(action_type == this.action_type.APPROVE && item.params.sub_type==this.sub_type.RESOLUTION) {
                return {name: 'issues-resolution', params: {issue_type: issue_type, issue_id: issue_id}}

            } else if(action_type == this.action_type.REJECT && item.params.sub_type==this.sub_type.RESOLUTION) {
                return {name: 'issues-resolution', params: {issue_type: issue_type, issue_id: issue_id}}

            } else if(action_type == this.action_type.CHANGE_ASSIGNEE) {
                return null
            }
        },
        get_safety_program_router_link(item) {
            let safety_program_id = item.related_id
            let action_type = item.action_type

            if (action_type == this.action_type.CREATE) {
                return {name: 'safety-program-view', params: {safety_program_id: safety_program_id}}

            } else if(action_type == this.action_type.REJECT && item.params.sub_type==this.sub_type.APPROVAL) {
                return {name: 'safety-program-edit', params: {safety_program_id: safety_program_id}}

            } else if(action_type == this.action_type.UPDATE && item.params.sub_type==this.sub_type.APPROVAL) {
                return {name: 'safety-program-view', params: {safety_program_id: safety_program_id}}

            } else if(action_type == this.action_type.APPROVE && item.params.sub_type==this.sub_type.APPROVAL) {
                return {name: 'safety-program-resolution', params: {safety_program_id: safety_program_id}}

            } else if(action_type == this.action_type.SUBMIT_RESOLUTION && item.params.sub_type==this.sub_type.RESOLUTION) {
                return {name: 'safety-program-resolution', params: {safety_program_id: safety_program_id}}

            } else if(action_type == this.action_type.APPROVE && item.params.sub_type==this.sub_type.RESOLUTION) {
                return {name: 'safety-program-resolution', params: {safety_program_id: safety_program_id}}

            } else if(action_type == this.action_type.REJECT && item.params.sub_type==this.sub_type.RESOLUTION) {
                return {name: 'safety-program-resolution', params: {safety_program_id: safety_program_id}}

            } else if(action_type == this.action_type.CHANGE_ASSIGNEE) {
                return null
            }
        },
        get_mm_dpr_entry_router_link(item) {
            const dpr_type  = item.module
            const dpr_entry_id = item.related_id
            const action_type = item.action_type

            if (action_type == this.action_type.CREATE) {
                return {name: 'dpr-entries', params: {issue_type: 'major_maintenance', module_key: dpr_type}, query: {search: dpr_entry_id}}

            } else if(action_type == this.action_type.REJECT) {
                return {name: 'dpr-entry-edit', params: {issue_type: 'major_maintenance', module_key: dpr_type, dpr_entry_id: dpr_entry_id}}

            } else if(action_type == this.action_type.UPDATE) {
                return {name: 'dpr-entries', params: {issue_type: 'major_maintenance', module_key: dpr_type}, query: {search: dpr_entry_id}}

            }  else if(action_type == this.action_type.APPROVE) {
                return {name: 'dpr-entries', params: {issue_type: 'major_maintenance', module_key: dpr_type}, query: {search: dpr_entry_id}}
            }
        },
        get_rm_dpr_monthly_router_link(item) {
            // dpr-report-view
            const report_id = item.params.data.report;
            const month = item.params.data.month;
            const year = item.params.data.year;
            const package_ = item.params.data.package;
            return {name: 'dpr-report-view', params: {issue_type: 'routine_maintenance', report_id: report_id}, query: {month: month, year: year, package: package_}}
        },
        get_rm_dpr_daily_router_link(item) {
            // dpr-report-view
            const report_id = item.params.data.report;
            const date = item.params.data.date;
            const package_ = item.params.data.package;
            return {name: 'dpr-report-transaction', params: {issue_type: 'routine_maintenance'}, query: {report: report_id, date: date, package: package_}}
        },
        get_message(item) {

            if (item.notification_type == this.notification_type.ISSUE) {
                return this.get_issue_message(item)

            } else if (item.notification_type == this.notification_type.SAFETY_PROGRAM) {
                return this.get_safety_program_message(item)

            }  else if (item.notification_type == this.notification_type.DPR && item.params.sub_type == this.dpr_sub_type.DPR_MONTHLY ) {
                return this.get_rm_dpr_monthly_message(item)

            } else if (item.notification_type == this.notification_type.DPR && item.params.sub_type == this.dpr_sub_type.DPR_ENTRY ) {
                return this.get_mm_dpr_entry_message(item)

            } else if (item.notification_type == this.notification_type.DPR && item.params.sub_type == this.dpr_sub_type.DPR_DAILY ) {
                return this.get_rm_dpr_daily_message(item)
            }
        },
        get_issue_message(item) {

            const action_type = item.action_type
            const issue_type = this.issue_type[item.module]
            const role = item.params.data.role
            const user = item.params.data.user
            const child_related_id = item.child_related_id
            let res;

            if (action_type == this.action_type.CREATE) {
                res = `Issue created by ${user} (${role}) for ${issue_type}.`

            } else if(action_type == this.action_type.REJECT && item.params.sub_type==this.sub_type.APPROVAL) {
                res = `Issue rejected by ${user} (${role}) for ${issue_type}.`

            } else if(action_type == this.action_type.UPDATE && item.params.sub_type==this.sub_type.APPROVAL) {
                res = `Issue updated by ${user} (${role}) for ${issue_type}.`

            } else if(action_type == this.action_type.APPROVE && item.params.sub_type==this.sub_type.APPROVAL) {
                res = `Issue approved by ${user} (${role}) for ${issue_type}.`

            } else if(action_type == this.action_type.SUBMIT_RESOLUTION && item.params.sub_type==this.sub_type.RESOLUTION) {
                res = `Issue submit resolution done by ${user} (${role}) for ${issue_type}.`

            } else if(action_type == this.action_type.APPROVE && item.params.sub_type==this.sub_type.RESOLUTION) {
                res = `Issue resolution approved by ${user} (${role}) for ${issue_type}.`

            } else if(action_type == this.action_type.REJECT && item.params.sub_type==this.sub_type.RESOLUTION) {
                res = `Issue resolution rejected by ${user} (${role}) for ${issue_type}.`

            }  else if(action_type == this.action_type.CHANGE_ASSIGNEE) {
                res = `Issue Assignee has been changed for ${issue_type}.`
            }

            if (child_related_id) res = res.concat(`(ID:#${child_related_id})`)

            return res
        },
        get_safety_program_message(item) {

            const action_type = item.action_type
            const role = item.params.data.role
            const user = item.params.data.user
            const related_id = item.related_id
            let res;

            if (action_type == this.action_type.CREATE) {
                res = `Safety Program created by ${user} (${role}).`

            } else if(action_type == this.action_type.REJECT && item.params.sub_type==this.sub_type.APPROVAL) {
                res = `Safety Program rejected by ${user} (${role}).`

            } else if(action_type == this.action_type.UPDATE && item.params.sub_type==this.sub_type.APPROVAL) {
                res = `Safety Program updated by ${user} (${role}).`

            } else if(action_type == this.action_type.APPROVE && item.params.sub_type==this.sub_type.APPROVAL) {
                res = `Safety Program approved by ${user} (${role}).`

            } else if(action_type == this.action_type.SUBMIT_RESOLUTION && item.params.sub_type==this.sub_type.RESOLUTION) {
                res = `Safety Program resolution submitted by ${user} (${role}).`

            } else if(action_type == this.action_type.APPROVE && item.params.sub_type==this.sub_type.RESOLUTION) {
                res = `Safety Program resolution approved by ${user} (${role}).`

            } else if(action_type == this.action_type.REJECT && item.params.sub_type==this.sub_type.RESOLUTION) {
                res = `Safety Program resolution rejected by ${user} (${role}).`

            } else if(action_type == this.action_type.CHANGE_ASSIGNEE) {
                res = `Safety Program Assignee has been changed.`
            }

            if (related_id) res = res.concat(`(ID:#${related_id})`)

            return res
        },
        get_mm_dpr_entry_message(item) {

            const action_type = item.action_type
            const role = item.params.data.role
            const user = item.params.data.user
            const mm_dpr_type = this.mm_dpr_type[item.module]
            const child_related_id = item.child_related_id
            let res;

            if (action_type == this.action_type.CREATE) {
                res = `Major Maintenance/${mm_dpr_type}/DPR is created by ${user} (${role}).`

            } else if(action_type == this.action_type.REJECT) {
                res = `Major Maintenance/${mm_dpr_type}/DPR is rejected by ${user} (${role}).`

            } else if(action_type == this.action_type.UPDATE) {
                res = `Major Maintenance/${mm_dpr_type}/DPR is updated by ${user} (${role}).`

            }  else if(action_type == this.action_type.APPROVE) {
                res = `Major Maintenance/${mm_dpr_type}/DPR is approved by ${user} (${role}).`
            }

            if (child_related_id) res = res.concat(`(ID:#${child_related_id})`)

            return res
        },
        get_rm_dpr_monthly_message(item) {
            const action_type = item.action_type
            const user = item.params.data.user
            const package_name = item.params.data.package_name
            const report_name = item.params.data.report_name
            const month = this.month_value[item.params.data.month]
            const year = item.params.data.year
            const role = item.params.data.role

            if (action_type == this.action_type.CREATE) {
                return `Routine Maintenance ${report_name}/${package_name} DPR Monthly Entry is last edited by ${user} (${role}) for ${month}-${year}.`

            } else if(action_type == this.action_type.REJECT) {
                return `Routine Maintenance ${report_name}/${package_name} DPR Monthly Entry is rejected by ${user} (${role}) for ${month}-${year}.`

            } else if(action_type == this.action_type.APPROVE) {
                return `Routine Maintenance ${report_name}/${package_name} DPR Monthly Entry is approved by ${user} (${role}) for ${month}-${year}.`

            }
        },
        get_rm_dpr_daily_message(item) {
            const action_type = item.action_type
            const user = item.params.data.user
            const package_name = item.params.data.package_name
            const report_name = item.params.data.report_name
            const date = item.params.data.date
            const role = item.params.data.role

            if (action_type == this.action_type.CREATE) {
                return `Routine Maintenance ${report_name}/${package_name} DPR Daily Entry is edited by ${user} (${role}) for ${date}.`

            } else if(action_type == this.action_type.VERIFY_REJECT) {
                return `Routine Maintenance ${report_name}/${package_name} DPR Daily Entry verification rejected by ${user} (${role}) for ${date}.`

            } else if(action_type == this.action_type.VERIFY_APPROVE) {
                return `Routine Maintenance ${report_name}/${package_name} DPR Daily Entry verification approved by ${user} (${role}) for ${date}.`

            } else if(action_type == this.action_type.REJECT) {
                return `Routine Maintenance ${report_name}/${package_name} DPR Daily Entry is rejected by ${user} (${role}) for ${date}.`

            } else if(action_type == this.action_type.APPROVE) {
                return `Routine Maintenance ${report_name}/${package_name} DPR Daily Entry is approved by ${user} (${role}) for ${date}.`
            }
        },
        get_subtitle(item) {
            return moment(item.created_on).format('DD MMM, YYYY hh:mm A')
        },
    }
}
</script>
